/* eslint-disable */

import Config from '@/app/game/data/config';
import Ball from '@/app/game/elements/Ball';
import Present from '@/app/game/elements/Present';
import Ornament from '@/app/game/elements/Ornament';
import Snowball from '@/app/game/elements/Snowball';
import ScorePlopper from '@/app/game/elements/ScorePlopper';

export default class BoxContainer extends PIXI.Container
{
    constructor( settings )
    {
        super();
        this.settings = settings;
        this.balls = [];
        this.presents = [];
        this.ornaments = [];
        this.snowballs = [];
    }

    spawnBalls()
    {
        let totalLayers = Config.BALL_LAYERS;
        let ballsPerRow = Math.floor( Config.AREA_MAX / Config.BALL_SIZE );

        for( let l = 0; l < totalLayers; l++ )
        {
            let layerOffset = (( Config.AREA_MAX - Config.AREA_MIN ) / 2 ) - ( Config.AREA_MAX - Config.AREA_MIN ) / 2 / ( totalLayers - 1 ) * l;
            let scale = Config.SCALE_MIN + ( Config.SCALE_MAX - Config.SCALE_MIN ) / (totalLayers - 1) * l;
            let brightness = Config.BRIGHTNESS_MIN + ( Config.BRIGHTNESS_MAX - Config.BRIGHTNESS_MIN ) / (totalLayers - 1) * l;

            let ballSize = Config.BALL_SIZE * scale;

            for( let i = 0; i < ballsPerRow; i++ )
            {
                for( let j = 0; j < ballsPerRow; j++ )
                {
                    let id = l * Math.pow( ballsPerRow, 2 ) +  i * ballsPerRow + j;

                    let fluctuation = Math.random() * Config.BALL_SIZE / 2 - Config.BALL_SIZE / 4;

                    let x = j * ballSize + layerOffset + fluctuation + 25;
                    let y = i * ballSize + layerOffset + fluctuation + 25;

                    let ball = new Ball({ id: id, x: x, y: y, z: l, scale: scale, ballSize: ballSize, brightness: brightness });
                    ball.eventHub.once( 'ballSuicide' + id, this.councelling.bind( this, ball ) );

                    ball.name = 'ball' + i;

                    this.balls.push( ball );
                    this.addChild( ball.sprite );
                }
            }
        }
    }

    spawnPresents()
    {
        for( var i = 0; i < 5; i++ )
        {
            let layer = 4 - i - 1;
            let scale = Config.SCALE_MIN + ( Config.SCALE_MAX - Config.SCALE_MIN ) / ( Config.BALL_LAYERS - 1 ) * layer;
            let brightness = Config.BRIGHTNESS_MIN + ( Config.BRIGHTNESS_MAX - Config.BRIGHTNESS_MIN ) / ( Config.BALL_LAYERS - 1 ) * layer;

            let ballSize = Config.BALL_SIZE * scale;

            let id = i + 1;
            let present = new Present({ index: i, id: id, x: Math.random() * 400 + 50, y: Math.random() * 400 + 50, z: layer, ballSize: ballSize, scale: scale, brightness: brightness });

            present.eventHub.once( 'presentSuicide' + id, this.councelling.bind( this, present ) );
            this.presents.push( present );

            this.addChild( present.sprite );
        }
    }

    spawnOrnaments()
    {
        for( var i = 0; i < Config.NUM_ORNAMENTS; i++ )
        {
            let layer = i % ( Config.BALL_LAYERS - 1 );
            let scale = Config.SCALE_MIN + ( Config.SCALE_MAX - Config.SCALE_MIN ) / ( Config.BALL_LAYERS - 1 ) * layer;
            let brightness = Config.BRIGHTNESS_MIN + ( Config.BRIGHTNESS_MAX - Config.BRIGHTNESS_MIN ) / ( Config.BALL_LAYERS - 1 ) * layer;

            let ballSize = Config.BALL_SIZE * scale;

            let id = i + 1;
            let ornament = new Ornament({ id: id, x: Math.random() * 400 + 50, y: Math.random() * 400 + 50, z: layer, ballSize: ballSize, scale: scale, brightness: brightness });

            ornament.eventHub.once( 'ornamentSuicide' + id, this.councelling.bind( this, ornament ) );
            this.ornaments.push( ornament );

            this.addChild( ornament.sprite );
        }
    }

    spawnSnowballs()
    {
        for( var i = 0; i < Config.NUM_SNOWBALLS; i++ )
        {
            let layer = i % ( Config.BALL_LAYERS - 1 );
            let scale = Config.SCALE_MIN + ( Config.SCALE_MAX - Config.SCALE_MIN ) / ( Config.BALL_LAYERS - 1 ) * layer;
            let brightness = Config.BRIGHTNESS_MIN + ( Config.BRIGHTNESS_MAX - Config.BRIGHTNESS_MIN ) / ( Config.BALL_LAYERS - 1 ) * layer;

            let ballSize = Config.BALL_SIZE * scale;

            let id = i + 1;
            let snowball = new Snowball({ id: id, x: Math.random() * 400 + 50, y: Math.random() * 400 + 50, z: layer, ballSize: ballSize, scale: scale, brightness: brightness });

            snowball.eventHub.once( 'snowballSuicide' + id, this.councelling.bind( this, snowball ) );
            this.snowballs.push( snowball );

            this.addChild( snowball.sprite );
        }
    }

    checkBrightness()
    {
        let result = this.balls.filter( pBall => pBall.z === Config.BALL_LAYERS - 1 );

        if( result.length <= 60 )
        {
            this.adjustBrightness();
        }
    }

    adjustBrightness()
    {
        let adjustArray = this.balls.filter( pBall => pBall.z < Config.BALL_LAYERS - 1 );
        for( let ball of adjustArray )
        {
            ball.updateBrightness();
        }
    }

    updateLayerOrder()
    {
        this.children.sort( ( a, b ) =>
        {
            a.zIndex = a.zIndex || 0;
            b.zIndex = b.zIndex || 0;
            return a.zIndex - b.zIndex;
        });
    }

    councelling( pElem )
    {
        // are you sure?
        let testArray = this.balls;

        if( pElem.name.indexOf( 'present' ) !== -1 )
        {
            testArray = this.presents;
            let scorePlopper = new ScorePlopper({ x: pElem.pos.x, y: pElem.pos.y, payload: { score: 900, id: pElem.id, version2: this.settings.version2, index: pElem.name.slice( -1 ) } });
            this.addChild( scorePlopper.sprite );
            PIXI.sound.play( 'sound-cadeautje', { singleInstance: true });
        }
        else if( pElem.name.indexOf( 'ornament' ) !== -1 )
        {
            testArray = this.ornaments;
            let scorePlopper = new ScorePlopper({ x: pElem.pos.x, y: pElem.pos.y, payload: { time: 5 } });
            this.addChild( scorePlopper.sprite );
            PIXI.sound.play( 'sound-kerstbal', { singleInstance: true });
        }
        else if( pElem.name.indexOf( 'snowball' ) !== -1 )
        {
            testArray = this.snowballs;

            let scorePlopper;
            if( this.settings.version2 === true )
            {
                scorePlopper = new ScorePlopper({ x: pElem.pos.x, y: pElem.pos.y, payload: { time: 10 } });
            }
            else
            {
                scorePlopper = new ScorePlopper({ x: pElem.pos.x, y: pElem.pos.y, payload: { score:-100 } });
            }

            this.addChild( scorePlopper.sprite );
            PIXI.sound.play( 'sound-sneeuwbal', { singleInstance: true });
        }

        let index = testArray.findIndex( pElemInArray =>
        {
            return pElemInArray === pElem;
        });

        testArray.splice( index, 1 );
        pElem.destroy();

        this.checkBrightness();
    }

    endAnim( pCallback )
    {
        this.removeList = [];

        for( let i = Config.BALL_LAYERS; i >= 0; i-- )
        {
            let currentLayer = [];
            currentLayer.push( this.balls.filter( item => item.z === i ) );
            currentLayer.push( this.ornaments.filter( item => item.z === i ) );
            currentLayer.push( this.snowballs.filter( item => item.z === i ) );

            for( let j = 0; j < currentLayer.length; j++ )
            {
                this.removeList = this.removeList.concat( currentLayer[j] );
            }
        }

        let tl = new TimelineMax({ paused: true });

        for( let i = 0; i < this.removeList.length; i++ )
        {
            tl.add( this.removeList[i].fancyRemove.bind( this.removeList[i] ), i * 1 );
        }

        TweenMax.fromTo( tl, 4, { progress: 0 }, { progress: 1, ease: Power2.easeInOut, onComplete: pCallback });
    }
};



// WEBPACK FOOTER //
// ./src/app/game/elements/BoxContainer.js